import { globalGraph } from "./schema";

// Global site-wide structured data: Organization + LocalBusiness + WebSite.
export const GlobalSchema = () => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{ __html: JSON.stringify(globalGraph) }}
  />
);
